export default function SwiperService({ data }) {
  return (
    <img
      style={{ maxHeight: "100%", objectFit: "contain" }}
      src={data}
      alt=""
    />
  );
}
